/**
 * Nome di un magazzino (tabella `warehouse_zones`) come lo vede l'utente:
 * "CODICE - Nome". Vale ovunque un magazzino viene indicato o scelto (filtri,
 * menu a tendina, movimenti, trasformazioni, stampe): con nomi simili il codice
 * evita di sbagliare magazzino.
 *
 * Senza codice resta solo il nome; senza nome solo il codice. Per ordinare le
 * tendine conviene ordinare per questo stesso testo.
 */
export function formatWarehouseName(
  zone: { code?: string | null; name?: string | null } | null | undefined,
  fallback = '',
): string {
  if (!zone) return fallback;
  const code = zone.code?.trim();
  const name = zone.name?.trim();
  if (code && name) return code === name ? name : `${code} - ${name}`;
  return name || code || fallback;
}
